'use strict';

export default class UsersController {
  /*@ngInject*/
  constructor($rootScope, $http, $q, $state, $stateParams, $uibModal, Modal) {
    this.$http = $http;
    this.$q = $q;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$uibModal = $uibModal;
    this.Modal = Modal;

    $rootScope.currentAdminPageTitle = 'Users';
    this.route = 'admin.users';

    this.tableMsg = '';
    this.form = {};
    this.roleOptions = ['user', 'admin'];
    this.systemOptions = [];
    this.result = {};
    this.pageSizeOptions = [10, 20, 30, 40, 50];
    this.sortByOptions = {
      name: 'Name',
      email: 'Email',
      lastLoggedIn: 'Last Logged In'
    };
    this.pagination = {
      _paging: true,
      _selector: 'All',
      _pageSize: 10,
      _pageNum: 1,
      _sortBy: 'lastLoggedIn desc'
    };
  }

  getSystems() {
    let deferred = this.$q.defer();
    let self = this;
    let params = {
      _selector: 'name',
      _pageSize: 'All'
    };
    this.$http.get(`/api/types/systems`, { params: params })
      .then(function(response) {
        self.systemOptions = response.data;
        deferred.resolve();
      }, function(err) {
        deferred.resolve();
      });
    return deferred.promise;
  }

  setDefaultSearchForm() {
    let _pageNum = 1;
    if(this.$stateParams._pageNum) {
      _pageNum = parseInt(this.$stateParams._pageNum);
    }
    this.pageNumVal = _pageNum;
    let _pageSize = 100;
    if(this.$stateParams._pageSize) {
      _pageSize = parseInt(this.$stateParams._pageSize);
    }
    this.pageSizeVal = _pageSize;
  }

  buildQuery() {
    return angular.extend(angular.copy(this.form), this.pagination);
  }

  getData() {
    let self = this;
    this.$http.get('/api/users', {
        params: this.buildQuery()
      })
      .then(function(response) {
        angular.forEach(response.data.items, function(item) {
          if(item.system && item.system.length) {
            item.systems = item.system.join(', ');
          }
        });
        if(response.data.total === 0) {
          self.tableMsg = 'No record found.';
        }
        self.result = response.data;
      }, function(err) {

      });
  }

  search(form) {
    this.pagination._pageNum = 1;
    this.getData();
  }

  clearSearch() {
    this.form = {};
    this.pagination._pageNum = 1;
    this.getData();
  }

  openUserModal(user) {
    let self = this;
    let modalInstance = this.$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: require('./partial/user.modal.html'),
      controller: 'UserModalController',
      controllerAs: '$ctrl',
      size: 'md',
      resolve: {
        user: function() {
          return user;
        }
      }
    });
    modalInstance.result.then(function() {
      self.getData();
    }, function() {

    });
  }

  openUserPasswordModal(user) {
    let self = this;
    let modalInstance = this.$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: require('./partial/userPassword.modal.html'),
      controller: 'UserPasswordModalController',
      controllerAs: '$ctrl',
      size: 'md',
      resolve: {
        user: function() {
          return user;
        }
      }
    });
    modalInstance.result.then(function() {
      self.getData();
    }, function() {

    });
  }

  delete(item) {
    let self = this;
    this.Modal.confirm.delete(function() {
      self.$http.delete(`/api/users/${item._id}`)
        .then(function(response) {
          self.getData();
        }, function(err) {

        });
    })(`${item.name}`);
  }

  // Row number
  rowNumb(idx) {
    return (idx + 1) + (this.data.results.pageNum !== 1 ? ((this.data.results.pageSize * this.data.results.pageNum) - this.data.results.pageSize) : 0);
  }

  renderCompleted() {
    this.tableRendered = true;
  }

  updateSortBy(sortBy) {
    this.pagination._sortBy = sortBy;
    this.$state.go(this.route, this.buildQuery(), {notify: false});
    this.getData();
  }

  updatePageSize(pageSize) {
    this.pagination._pageSize = pageSize;
    this.pagination._pageNum = 1;
    this.$state.go(this.route, this.buildQuery(), {notify: false});
    this.getData();
  }

  gotoPage(pageNum) {
    this.pagination._pageNum = pageNum;
    this.$state.go(this.route, this.buildQuery(), {notify: false});
    this.getData();
  }

  $onInit() {
    let self = this;
    this.getSystems().then(function() {
      if(window.system) {
        self.form.system = window.system;
      }
      self.getData();
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/users.controller.js